/* ============================================================
   BULIER — GLI EVENTI NOSTRI, PER IL PIXEL

   Shopify registra da solo pagine viste, prodotti visti, ricerche,
   carrello, checkout e acquisti (eventi "standard"). Qui ci sono solo
   le cose che Shopify non puo' sapere, pubblicate come eventi
   personalizzati con Shopify.analytics.publish.

   Chi li raccoglie e' il pixel personalizzato (Shopify > Impostazioni >
   Eventi dei clienti), che li manda al database di SEMPLIFY. Finche' il
   pixel non c'e' questi eventi non vanno da nessuna parte: non danno
   fastidio. Il consenso ai cookie lo gestisce Shopify: il pixel riceve
   gli eventi solo da chi ha accettato le statistiche.

   NESSUN DATO PERSONALE: solo handle di look, prodotti e articoli.

   Eventi (decisione di Andrea del 30/09, vault: Look BULIER):
     look_visto              una scheda look e' entrata nello schermo
     look_capo_cliccato      clic su un capo dentro una scheda look
     look_aggiunto_carrello  (lo pubblica bulier.js dopo l'aggiunta)
     magazine_articolo_letto l'articolo e' stato letto fino in fondo
     magazine_punto_aperto   aperta la schedina di un capo su una foto
     magazine_capo_cliccato  clic su "Vedi il capo" o sulla didascalia
   ============================================================ */
(function(){
  window.bulierEvento = function(nome, dati){
    try{
      if(window.Shopify && Shopify.analytics && Shopify.analytics.publish){
        Shopify.analytics.publish(nome, dati || {});
      }
    }catch(e){ /* un evento perso non deve mai rompere la pagina */ }
  };
  const evento = window.bulierEvento;
  const articolo = document.querySelector('[data-mg-articolo]');
  const quale = articolo ? articolo.dataset.mgArticolo : '';

  /* ---------- look visti: una volta per look per pagina ---------- */
  const visti = new Set();
  if('IntersectionObserver' in window){
    const guarda = new IntersectionObserver(voci => voci.forEach(v => {
      if(!v.isIntersecting) return;
      const h = v.target.dataset.lookHandle;
      if(h && !visti.has(h)){ visti.add(h); evento('look_visto', { look: h, pagina: location.pathname }); }
      guarda.unobserve(v.target);
    }), { threshold: .5 });
    document.querySelectorAll('[data-look-scheda]').forEach(s => guarda.observe(s));
  }

  /* ---------- clic ---------- */
  document.addEventListener('click', e => {
    const capoLook = e.target.closest('[data-look-scheda] a[href*="/products/"]');
    if(capoLook){
      evento('look_capo_cliccato', {
        look: capoLook.closest('[data-look-scheda]').dataset.lookHandle || '',
        prodotto: capoLook.pathname.split('/products/')[1] || ''
      });
    }
    const punto = e.target.closest('.mg-punto');
    if(punto) evento('magazine_punto_aperto', { articolo: quale, capo: punto.getAttribute('aria-label') || '' });

    const capoMg = e.target.closest('.mg a[href*="/products/"]');
    if(capoMg && !capoLook){
      evento('magazine_capo_cliccato', { articolo: quale, prodotto: capoMg.pathname.split('/products/')[1] || '' });
    }
  }, true);

  /* ---------- articolo letto: arrivati alla fine del testo ---------- */
  const fine = document.querySelector('[data-mg-fine]');
  if(fine && 'IntersectionObserver' in window){
    const letto = new IntersectionObserver(voci => {
      if(voci.some(v => v.isIntersecting)){ evento('magazine_articolo_letto', { articolo: quale }); letto.disconnect(); }
    });
    letto.observe(fine);
  }
})();
